export default __webpack_public_path__ + "static/0301-d55ef463f8697e70c4fbf59691e6b582.png";